import { defineComponent as _defineComponent } from 'vue'
import { useSubCompaniesStore } from "@/pinia/subcompanies/subcompanies";
import { storeToRefs } from "pinia";
import { getStatus } from "@/services/status";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { ref } from "vue";
import { SubCompanyModel } from "@/services/types/subCompanies";
import ConfirmationComponent from "@/components/modal/ConfirmationComponent.vue";
import EditSubcompanyFormModal from "@/components/company/forms/EditSubcompanyFormModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubCompaniesListTable',
  setup(__props) {

const { getFilteredCompanies, isDataLoading } = storeToRefs(
  useSubCompaniesStore()
);

//#region Actions

const selectedCompany = ref<SubCompanyModel>();
const editCompanyModalShow = ref(false);
const deleteCompanyModalShow = ref(false);

function handleEditCompanyClick(company: SubCompanyModel) {
  selectedCompany.value = company;
  editCompanyModalShow.value = true;
}

function handleDeleteCompanyClick(company: SubCompanyModel) {
  selectedCompany.value = company;
  deleteCompanyModalShow.value = true;
}

function cancleDeleteCompany() {
  selectedCompany.value = null;
  deleteCompanyModalShow.value = false;
}

async function deleteComapny() {
  const store = useSubCompaniesStore();
  await store.deleteSubCompanies([selectedCompany.value.id]);
  cancleDeleteCompany();
  await store.fetchSubCompanies();
}

//#endregion

//#region Config

const actionsIcon = faEllipsisV;
const fields = [
  {
    key: "name",
    sortable: true,
    label: "Название",
    tdClass: "name-td",
    thClass: "name-th",
  },
  {
    key: "status",
    sortable: true,
    label: "Статус",
    tdClass: "status-td",
    thClass: "status-th",
  },
  {
    key: "users",
    sortable: true,
    label: "Пользователи",
    tdClass: "users-td",
    thClass: "users-th",
  },
  {
    key: "action",
    label: "",
    sortable: false,
    tdClass: "action-td",
    thClass: "action-th",
  },
];

//#enregion

return { __sfc: true,getFilteredCompanies, isDataLoading, selectedCompany, editCompanyModalShow, deleteCompanyModalShow, handleEditCompanyClick, handleDeleteCompanyClick, cancleDeleteCompany, deleteComapny, actionsIcon, fields, getStatus, ConfirmationComponent, EditSubcompanyFormModal }
}

})